export default "__VITE_ASSET__tNhC7Vqs__"